export const environment = {
  production: false,
  apiUrl: 'http://localhost:5180/graphql',
  restUrl: 'http://localhost:5180'
};
